import useMediaQuery from "@mui/material/useMediaQuery";
import Carousel from "react-material-ui-carousel";
import { default as MultiCarousel } from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useSelector } from "react-redux";
import { IoIosStar } from "react-icons/io";
import { getCustomerReviews } from "../../../../redux/selectors/webConfigSelector";
import "./Slider.css";
import * as S from "./CustomerReview.style";
import "react-google-reviews/dist/index.css";
import { ReactGoogleReviews } from "react-google-reviews";

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
    slidesToSlide: 4,
  },
  tablet: {
    breakpoint: { max: 1024, min: 768 },
    items: 1,
    slidesToSlide: 3,
  },
};

const CustomDot = ({ onMove, index, onClick, active }: any) => {
  return (
    <li
      className={active ? "active" : "inactive"}
      onClick={() => onClick()}
    ></li>
  );
};

const CustomerReviews = () => {
  const isMweb = useMediaQuery("(max-width:786px)");
  const customerReviews = useSelector(getCustomerReviews) || [];
  return (
    <>
      <S.CustomerReviewsContainer>
        <S.Heading>
          More than 40,000 reviews on Google with 4.9
          <IoIosStar size={24} style={{ color: "orange" }} /> rating!
        </S.Heading>
        <S.ReviewContainer>
          <ReactGoogleReviews
            featurableId="84f7a8da-38de-466f-9923-1353443f7943"
            layout="carousel"
          />
        </S.ReviewContainer>
      </S.CustomerReviewsContainer>
      <S.MwebCustomerReviewsContainer>
        <S.Heading>
          More than 40,000 reviews on Google with 4.9
          <IoIosStar size={24} style={{ color: "orange" }} /> rating!
        </S.Heading>

        <ReactGoogleReviews
          featurableId="84f7a8da-38de-466f-9923-1353443f7943"
          layout="carousel"
        />
      </S.MwebCustomerReviewsContainer>
    </>
  );
};
export default CustomerReviews;
